import { Component, OnInit, Output, EventEmitter } from '@angular/core';

export type OdlStatsFilterOptions = {
    tipo_cliente : string,
    tipo_intervento : string,
    report_type : 'generale' | 'tipo_intervento' | 'tipo_cliente',
}

@Component({
    selector: 'odl-stats-filters',
    templateUrl: './odl-stats-filters.component.html',
    styleUrls: ['./odl-stats-filters.component.scss']
})
export class OdlStatsFiltersComponent implements OnInit {
    
    @Output() changed: EventEmitter<OdlStatsFilterOptions> = new EventEmitter<OdlStatsFilterOptions>();

    public filter_options: OdlStatsFilterOptions = {
        tipo_cliente: '',
        tipo_intervento : '',
        report_type : 'generale',
    }


    constructor() { }

    ngOnInit() {
        
    }

    filter() {
        this.filter_options.report_type = 'generale';
        this.changed.emit(this.filter_options);
    }

    showGeneral() {
        this.filter_options.report_type = 'generale';
        this.changed.emit(this.filter_options);
    }

    showByType() {
        this.filter_options.report_type = 'tipo_intervento';
        this.changed.emit(this.filter_options);
    }

    showByCustomer(){
        this.filter_options.report_type = 'tipo_cliente';
        this.changed.emit(this.filter_options);
    }

}
